import { faChevronCircleDown } from '@fortawesome/pro-light-svg-icons/faChevronCircleDown';
import { faEmptySet } from '@fortawesome/pro-solid-svg-icons/faEmptySet';
import { faSearch } from '@fortawesome/pro-solid-svg-icons/faSearch';
import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons/faSpinner';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { faMinus } from '@fortawesome/pro-solid-svg-icons/faMinus';

import { faCheckCircle as falCheckCircle } from '@fortawesome/pro-light-svg-icons';
import {
  faTimesCircle as farTimesCircle,
  faTags as farTags,
  faPlusCircle,
  faMinusCircle,
  faAddressCard as farAddressCard,
  faMoneyCheckEditAlt,
  faEye as farEye,
} from '@fortawesome/pro-regular-svg-icons';
import { faCaretUp, faCaretDown, faCaretLeft, faCaretRight, faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

//export array
export const icons = [
  faChevronCircleDown,
  faSearch,
  faEmptySet,
  faCircle,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronDown,
  faSpinner,
  falCheckCircle,
  farTimesCircle,
  faCaretUp,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faInfoCircle,
  farTags,
  faPlusCircle,
  faMinusCircle,
  farAddressCard,
  faMoneyCheckEditAlt,
  faPlus,
  faMinus,
  farEye,
];
